import React, { useEffect, useState } from "react";
import { fetchJobs } from "../api";
import { Link } from "react-router-dom";

const JobList = () => {
    const [jobs, setJobs] = useState([]);
    

    useEffect(() => {
        const getJobs = async () => {
            const data = await fetchJobs();
            setJobs(data);
        };
        getJobs();
    }, []);



    return (
        <div className="logo-container container mt-5">
            <h1 className="hire-echo-logo text-center mb-4">Hire<span style={{ color: "#ff5733" }}>Echo</span></h1>
            <div className="row">
                {jobs.map((job) => (
                    <div className="col-12 col-md-4 mb-4" key={job._id}>
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">{job.title}</h5>
                                <p className="card-text">
                                    <strong>Company:</strong> {job.company} <br />
                                    <strong>Location:</strong> {job.location}
                                </p>
                                <Link to={`/jobs/${job._id}`} className="btn btn-primary">
                                    View Details
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default JobList;
